import { React, useState, useEffect, useContext } from "react";
import { API_BASE_URL } from "../utils/config";
import axios from "axios";
import UploadImage from "../Img/upload.png";
import { toast } from "react-toastify";
import NewTopNavBar from "./NewTopNavBar";
import GlobalContext from "../context/GlobalContext";
import { Modal } from "react-bootstrap";
import UpdateImage from "../Img/update.png";
import Select from "react-select";
// import GlobalContext from '../context/GlobalContext';
const BroadCast = () => {
  const [message, setMessage] = useState("");
  const [favIconFile, setFavIconFile] = useState();
  let bearerToken = localStorage.getItem("jwt_token");
  const { logoUpload, setLogoUpload, notificationCount, setNotificationCount } =
    useContext(GlobalContext);
  const [usersDropDownKey, setUsersDropDownKey] = useState(0);
  const [selectedUserOption, setSelectedUserOption] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  // const { notificationCount, setNotificationCount } = useContext(GlobalContext)

  const config2 = {
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      "Content-Type": "application/json",
    },
  };
  useEffect(() => {
    fetch(`${API_BASE_URL}/wp-json/custom-user-api/v1/users`, {
      headers: {
        Authorization: `Bearer ${bearerToken}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((users) => {
        console.log("users=", users);
        let filterUsers = users.filter(
          (res) => res.ID != localStorage.getItem("current_user_Id")
        );
        setAllUsers(filterUsers);
        // Do something with the list of users
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }, []);
  const handleFileChange = (event) => {
    // setFeaturedImageLoading(true);

    console.log("263=", event.target.value);
    setMessage(event.target.value);
    // setSelectedFile(event.target.files[0]);
  };
  const handleCreateBroadCast = () => {
    console.log("line549=", selectedUserOption);
    if (message == "") {
      toast.error("Please enter a message for broadcast");
      return;
    }
    let notification_api_data;

    if (selectedUserOption.length > 0) {
      setNotificationCount(notificationCount + selectedUserOption.length);

      for (let i = 0; i < selectedUserOption.length; i++) {
        // usremail.push(selectedUserOption[i].user_email)
        notification_api_data = {
          author: localStorage.getItem("display_name"),
          notifications: message,
          value: true,
          notification_ids: selectedUserOption[i].ID,
          email: selectedUserOption[i].user_email,
          event_type: "broadcast",
          author_ids: localStorage.getItem("current_user_Id"),
          name: selectedUserOption[i].user_login,
        };
        //

        axios
          .get(
            `${API_BASE_URL}/wp-json/custom/v1/get-count/?user_id=${selectedUserOption[i].ID}`,
            config2
          )
          .then((res) => {
            console.log(res.data);

            let notification_count_specific_user = {
              user_id: selectedUserOption[i].ID,
              count_value: res.data.count_value + 1,
            };
            let notification_count = {
              user_id: "",
              count_value: notificationCount,
              reflect_count: "all_admin",
            };
            if (notification_count.user_id == "") {
              // post notification on usermeta start
              axios
                .post(
                  `${API_BASE_URL}/wp-json/custom/v1/store-count/`,
                  notification_count,
                  config2
                )
                .then((res) => {
                  console.log(res.data);
                })
                .catch((err) => {
                  console.log(err);
                });
            }
            if (notification_count_specific_user.user_id != "") {
              // post notification on usermeta start
              axios
                .post(
                  `${API_BASE_URL}/wp-json/custom/v1/store-count/`,
                  notification_count_specific_user,
                  config2
                )
                .then((res) => {
                  console.log(res.data);
                })
                .catch((err) => {
                  console.log(err);
                });
            }
          })
          .catch((err) => {
            console.log(err);
          });

        //
        axios
          .post(
            `${API_BASE_URL}/wp-json/custom/v1/insert-notification-data`,
            notification_api_data,
            config2
          )
          .then((res) => {
            console.log(res.data);
            setMessage("");
            setSelectedUserOption([]);
          })
          .catch((err) => {
            console.log(err);
          });
      }
      toast.success("Broadcast Created Successfully");
    } else {
      setNotificationCount(notificationCount + 1);
      notification_api_data = {
        author: localStorage.getItem("display_name"),
        // articles: aricleData.title.rendered,
        value: "false",
        notifications: message,
        event_type: "broadcast",
        author_ids: localStorage.getItem("current_user_Id"),
        email: localStorage.getItem("userEmail"),

        // name: author_name,
        // article_ids: postId,
      };

      //

      let notification_count = {
        user_id: "",
        count_value: notificationCount,
        reflect_count: "all",
      };
      if (notification_count.user_id == "") {
        // post notification on usermeta start
        axios
          .post(
            `${API_BASE_URL}/wp-json/custom/v1/store-count/`,
            notification_count,
            config2
          )
          .then((res) => {
            console.log(res.data);
          })
          .catch((err) => {
            console.log(err);
          });
      }

      //

      axios
        .post(
          `${API_BASE_URL}/wp-json/custom/v1/insert-notification-data`,
          notification_api_data,
          config2
        )
        .then((res) => {
          console.log(res.data);
          setMessage("");
          setSelectedUserOption([]);

          toast.success("Broadcast Created Successfully");
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  return (
    <div>
      <NewTopNavBar />
      <div className="container">
        <div className="row">
          <div className="col-3"></div>
          <div className="col-6">
            <div className="form-group pt-5 ">
              <label className="fw-bold">Broadcast Message:</label>

              <div className="d-flex align-items-center">
                <textarea
                  className="form-control my-2 "
                  // style={{ width: '75%' }}
                  type="input"
                  // accept="image/*"
                  id="file"
                  value={message}
                  label="Choose image upload"
                  onChange={handleFileChange}
                />
              </div>
              {/* recomandation modal start*/}
              <label className="fw-bold">Select Users:</label>

              <div className="">
                <Select
                  // classNames="w-50"
                  key={usersDropDownKey}
                  closeMenuOnSelect={false}
                  className="tagSelectorMulti"
                  isMulti={true}
                  placeholder="All Users"
                  getOptionLabel={(option) => option.user_login}
                  getOptionValue={(option) => option.ID}
                  options={allUsers}
                  onChange={setSelectedUserOption}
                  // defaultValue={selectedUserOption}
                />

                {/* <img onClick={handleCreateCategory} width={50} data-toggle="tooltip" data-placement="bottom" title="Add" role='button' src={UpdateImage} alt="Add" /> */}
              </div>
              <div className="d-flex justify-content-end mt-2">
                <img
                  className="ms-2 commonLogo"
                  // width={40}
                  onClick={handleCreateBroadCast}
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Create BroadCast"
                  role="button"
                  src={UpdateImage}
                  alt=""
                />
              </div>
              {/* recomandation modal end */}
            </div>
          </div>
          <div className="col-3"></div>
        </div>
      </div>
    </div>
  );
};

export default BroadCast;
